import Vue from "vue"

export default {
  namespaced: true,
  state: {
    loadAppointment: false,
    appointment: null,
    visibleModalFindClient: false,
    visibleModalAppointment: false,
    currentUser: null,
    currentDepartment: null,
    currentDate: new Date(),
  },
  mutations: {
    setAppointment(state, data) {
      state.appointment = data;
    },
    setLoad(state, data) {
      state.loadAppointment = data;
    },

    visibleModalFindClient(state, show) {
      state.visibleModalFindClient = show;
    },
    visibleModalAppointment(state, show) {
      state.visibleModalAppointment = show;
    },
    setCurrentUser(state, data) {
      state.currentUser = data
      state.visibleModalFindClient = false

    },
    setCurrentDepartment(state, data) {
      state.currentDepartment = data
    },
    setCurrentDate(state, data) {
      state.currentDate = data
    }
  },
  getters: {
    appointment: state => state.appointment,
    loadAppointment: state => state.loadAppointment,
    currentDate: state => state.currentDate,
    currentUser: state => state.currentUser,
    currentDepartment: state => state.currentDepartment,
    visibleModalFindClient: state => state.visibleModalFindClient,
    visibleModalAppointment: state => state.visibleModalAppointment,
  },
  actions: {
    OPEN_MODAL_FIND_CLIENT: function ({commit}) {
      commit('visibleModalFindClient', true);
    },
    CLOSE_MODAL_FIND_CLIENT: function ({commit}) {
      commit('visibleModalFindClient', false);
    },
    OPEN_MODAL_APPOINTMENT: function ({commit}) {
      commit('visibleModalAppointment', true);
    },
    CLOSE_MODAL_APPOINTMENT: function ({commit}) {
      commit('visibleModalAppointment', false);
    },
    SET_CURRENT_USER: function ({commit}, data) {
      commit('setCurrentUser', data);
    },
    SET_CURRENT_DATE: function ({commit}, data) {
      commit('setCurrentDate', data);
    },
    SET_CURRENT_DEPARTMENT: function ({commit}, data) {
      commit('setCurrentDepartment', data);
    },


    CLEAN_APPOINTMENT: function ({commit}) {
      commit('setAppointment', null);
    },

    GET_APPOINTMENT: async function ({commit}) {



      commit('setLoad', true)
      let params = {
        params: {
          date: this.getters['appointment/currentDate'],
        }
      }

      if(!this.getters['appointment/currentDepartment']) {
        commit('setLoad', false)
        return 0
      }

      Vue.prototype.$api.appointments
        .getList(this.getters['appointment/currentDepartment'].id, params)
        .then((response) => {
          commit('setAppointment', response.data);
        })
        .catch((response) => {
          Vue.prototype.$notify.error({
            title: "Ошибка загрузки планировщика",
            message: response.response.data.message,
          })
        }).finally(() => {
        commit('setLoad', false)
      })

    },


  }
};
